<template>
  <div>
    <a-form
      :form="form"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 12 }"
      @submit="handleSubmit"
    >
      <a-form-item label="手机号">
        <a-input
          :disabled="working"
          v-decorator="[
            'mobile',
            { rules: [{ required: true, message: '输入手机号' }] },
          ]"
        />
      </a-form-item>
      <a-button type="primary" html-type="submit" :disabled="working">
        {{ working ? "优化中..." : "优化数据" }}
      </a-button>
    </a-form>
  </div>
</template>

<script>
  import { post } from "@/utils/request";

  export default {
    data() {
      return {
        formLayout: "horizontal",
        form: this.$form.createForm(this, { name: "coordinated" }),
        working: false,
      };
    },
    methods: {
      handleSubmit(e) {
        e.preventDefault();
        this.form.validateFields((err, values) => {
          if (!err) {
            this.working = true;
            post("/data-process/optimization", {
              mobile: values.mobile,
            })
              .then(() => {
                this.$message.success("数据优化完成");
                this.working = false;
              })
              .catch((err) => {
                this.$message.error(err.response.data.msg);
                this.working = false;
              });
          }
        });
      },
    },
  };
</script>

<style scoped>
</style>